import * as definitions from 'store/definitions/people';

export function fetchPortugueses(page = 1, rowsPerPage, orderBy, order, search, checked, searchStatus, documentationStatus, customerStatus) {
    return {
        type: definitions.FETCH_PORTUGUESES,
        payload: { page, rowsPerPage, orderBy, order, search, checked, searchStatus, documentationStatus, customerStatus },
    };
}